var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmSubtract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C10.3683 21 8.77325 20.5161 7.41655 19.6096C6.05984 18.7031 5.00242 17.4146 4.378 15.9071C3.75357 14.3997 3.5902 12.7409 3.90853 11.1405C4.22685 9.54016 5.01259 8.07016 6.16637 6.91637C7.32016 5.76259 8.79017 4.97685 10.3905 4.65853C11.9909 4.3402 13.6497 4.50357 15.1571 5.128C16.6646 5.75242 17.9531 6.80984 18.8596 8.16655C19.7662 9.52325 20.25 11.1183 20.25 12.75C20.25 14.938 19.3808 17.0365 17.8336 18.5836C16.2865 20.1308 14.188 21 12 21ZM12 6C10.665 6 9.35994 6.39588 8.2499 7.13758C7.13987 7.87928 6.27471 8.93349 5.76382 10.1669C5.25293 11.4003 5.11925 12.7575 5.3797 14.0669C5.64015 15.3762 6.28303 16.579 7.22703 17.523C8.17104 18.467 9.37377 19.1099 10.6831 19.3703C11.9925 19.6308 13.3497 19.4971 14.5831 18.9862C15.8165 18.4753 16.8707 17.6101 17.6124 16.5001C18.3541 15.3901 18.75 14.085 18.75 12.75C18.75 10.9598 18.0388 9.2429 16.773 7.97703C15.5071 6.71116 13.7902 6 12 6Z",
    fill: "#265EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12H8.25V13.5H15.75V12Z",
    fill: "#67C2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3118 2.99609L17.25 4.05564L19.936 6.74723L20.9977 5.68768L18.3118 2.99609Z",
    fill: "#67C2E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68644 3.00195L3.00049 5.69354L4.06226 6.75309L6.74822 4.0615L5.68644 3.00195Z",
    fill: "#67C2E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmSubtract);
export default __webpack_public_path__ + "static/media/AlarmSubtract.96bfa0c90fb3a5e3f0cc8461b429b11c.svg";
export { ForwardRef as ReactComponent };